import { BiSend } from "react-icons/bi";
import { TbServer2 } from "react-icons/tb";
import { CiGrid31, CiMail, CiWheat } from "react-icons/ci";
import { FiHome, FiFileText } from "react-icons/fi";
import { MdOutlineDynamicForm } from "react-icons/md";
import { ImFilePicture, ImMoveUp } from "react-icons/im";
import { AiOutlineCode, AiOutlineUser } from "react-icons/ai";
import { BsBraces, BsTelephone } from "react-icons/bs";
import { HiOutlineBriefcase, HiOutlineLocationMarker } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";

import {
  beheroImages,
  neatourImages,
  nextorImages,
  palAgencyImages,
  shopImages,
  uiLibImages,
  limeLiteImages,
  alesayiImages,
  abacusImages,
  venuImages,
} from "./projects-images";

export const PROJECTS = [
  {
    name: "Limelite",
    // "": "Mobile app for connecting the general public with advertising film, tv, product research, social media and reality tv for on-camera work.",
    description:
      "Mobile app for non-actors and everyday people to connect with on-camera real people jobs in the entertainment and advertising industry across in US",
    images: limeLiteImages,
    demo: "https://play.google.com/store/apps/details?id=com.spotlite",
    // github: "https://github.com/ahmedghanim7/heros",
    tools: [
      "React-Native",
      "AWS",
      "Firebase Services",
      "React-Query",
      "Redux",
      "Formik & Yub",
      "RN-Navigation",
      "RN-File-system",
      "Web-Sockets",
    ],
  },
  {
    name: "Abacus",
    description:
      "Abacus is as app aimed at utilizing children's time by solving mathematical problems through games. Parents can track their children's progress and activity.",
    images: abacusImages,
    // github: "https://github.com/ahmedghanim7/heros",
    tools: [
      "React-Native",
      "mobx",
      "TypeScript",
      "Formik & Yub",
      "i18next for translation",
      "React-Query",
      "RN-Reanimated",
      "RN-Navigation",
    ],
  },

  {
    name: "Alesayi Store",
    description:
      "Alesayi Store Is an e-commerce platform in Sudia-Arabia for electronic devices.",
    images: alesayiImages,
    demo: "https://aecksa.com",
    tools: [
      "HTML/HTML5",
      "CSS/CSS3",
      "JavaScript",
      "Bootstrap",
      "PHP",
      "Laravel Blade",
    ],
  },
  {
    name: "Heroes Shop",
    thumbnailUrl: "",
    projectImages: [],
    description:
      "Is an e-commerce platform in The Middle east for the best products such as cell phones, electronic, toys & more products.Promotions on clothing, electronics, sports and more.",
    images: shopImages,
    demo: "https://heroes-team-shop.netlify.app/",
    github: "https://github.com/ahmedghanim7/heros",
    tools: [
      "ReactJS",
      "Redux-Toolkit",
      "TypeScript",
      "Styled-components",
      "Formik & Yub",
      "Stripe",
    ],
    features: [
      "Light & dark themes",
      "Good user experience",
      "Excellent performance on desktop",
      "Mobile friendly screens",
      "Safety & secure",
    ],
  },
  {
    name: "Pal Agency",
    description:
      "Real estate app make user's life easy to find and own their dream homes",
    images: palAgencyImages,
    github: "https://github.com/ahmedghanim7/pal-agency",
    tools: ["ReactJS", "NextJS", "Chakra-UI", "Framer-motion"],
  },
  {
    name: "The Venue",
    description: "Landing page for musical event.",
    images: venuImages,
    tools: ["ReactJS", "React-Slick", "React-Awesome-Reveal"],
  },
  {
    images: beheroImages,
    name: "Be Hero",
    description:
      "A quiz app allows users to test their knowledge in many topics like naturel, sports and policy.",
    demo: "https://beheroo.netlify.app/",
    github: "https://github.com/ahmedghanim7/quiz-app",
    tools: ["ReactJS", "TypeScript", "Styled-components"],
  },
  {
    name: "UI-Library",
    images: uiLibImages,
    description:
      "React UI library like Material-UI, contains five components are Dialog, Avatar, Typography, Skeleton and Card.",
    demo: "https://c-team-ui-library.netlify.app/",
    github: "https://github.com/ahmedghanim7/UI-Library",
    tools: ["ReactJS", "TypeScript", "Styled-components"],
  },
  {
    name: "Natours",
    images: neatourImages,
    description: "Landing page",
    demo: "",
    github: "https://github.com/ahmedghanim7/natours",
    tools: ["HTML/CSS", "SASS", "JavaScript"],
  },
  {
    name: "Nextor",
    images: nextorImages,

    description: "Landing page",
    demo: "",
    github: "https://github.com/ahmedghanim7/nextor",
    tools: ["html/css", "SASS", "javascript"],
  },
];

// limelite mobile and web
// LunchTrip , Boka, Al-Esayi

export const SKILLS = [
  {
    title: "Programming",
    subtitle: "More than 4 years",
    Icon: AiOutlineCode,
    content: [
      {
        name: "JavaScript",
        progress: 90,
      },
      {
        name: "Java",
        progress: 85,
      },
      {
        name: "Python",
        progress: 70,
      },
      {
        name: "OOP",
        progress: 75,
      },
      {
        name: "Data Structures",
        progress: 85,
      },
      {
        name: "Algorithms",
        progress: 70,
      },
      {
        name: "Design Patterns",
        progress: 60,
      },
    ],
  },
  {
    title: "Frontend Development",
    subtitle: "More than 3 years",
    Icon: BsBraces,
    content: [
      {
        name: "HTML/HTML5",
        progress: 90,
      },
      {
        name: "CSS/CSS3 & SASS",
        progress: 85,
      },
      {
        name: "JavaScript",
        progress: 90,
      },
      {
        name: "TypeScript",
        progress: 75,
      },
      {
        name: "ReactJS",
        progress: 90,
      },
      {
        name: "React-Native",
        progress: 85,
      },
      {
        name: "NextJS",
        progress: 80,
      },
      {
        name: "Redux & Redux-Toolkit",
        progress: 90,
      },
      {
        name: "Material UI",
        progress: 80,
      },
      {
        name: "TailwindCSS",
        progress: 75,
      },
      {
        name: "And a lot of more technologies such as AWS, GraphQL and Socket.io",
      },
    ],
  },
  {
    title: "Backend Development",
    subtitle: "One year",
    Icon: TbServer2,
    content: [
      {
        name: "NodeJS",
        progress: 80,
      },
      {
        name: "Express",
        progress: 75,
      },
      {
        name: "RESTful API",
        progress: 70,
      },
      {
        name: "SQL",
        progress: 75,
      },
      {
        name: " MySQL & PostgreSQL",
        progress: 70,
      },
      {
        name: "MongoDB",
        progress: 75,
      },
    ],
  },
];

export const NAV_LIST = [
  { name: "Home", Icon: FiHome },
  { name: "About", Icon: AiOutlineUser },
  { name: "Skills", Icon: FiFileText },
  { name: "Experience", Icon: FiFileText },
  { name: "Portfolio", Icon: ImFilePicture },
  { name: "Services", Icon: HiOutlineBriefcase },
  { name: "Contact", Icon: BiSend },
];

export const SERVICES_LIST = [
  {
    Icon: ImMoveUp,
    title: "Software Engineering",
    content: [
      "Designing, developing, testing, and maintaining software applications, systems, or platforms.",
      "Collaborating with stakeholders to gather and analyze requirements, and translating them into technical specifications and software solutions.",
      "Designing software architecture, including system structure, components, modules, and interfaces, to meet scalability, reliability, and performance requirements.",
      "Writing clean, efficient, and maintainable code according to coding standards and best practices, and ensuring adherence to design and architecture principles.",
      "Conducting unit tests, integration tests, and end-to-end tests to ensure software quality, reliability, and functionality, and debugging and fixing issues as needed.",
      "Writing technical documentation, including design documents, user manuals, API documentation, and release notes, to facilitate understanding, usage, and maintenance of software systems.",
      "Providing ongoing maintenance, support, and troubleshooting for deployed software applications, addressing bugs, performance issues, and user feedback.",
    ],
  },
  {
    Icon: MdOutlineDynamicForm,
    title: "Frontend Development",
    content: [
      "Translating UI/UX designs into responsive and interactive web or mobile interfaces.",
      "Creating reusable UI components and libraries to maintain consistency and streamline development across multiple projects.",
      "Developing responsive layouts and designs that adapt seamlessly to different screen sizes and devices, including desktops, tablets, and mobile phones.",
      "Ensuring that web applications are accessible to users with disabilities and optimized for search engines by following best practices and guidelines.",
      "Identifying and implementing performance optimizations to improve apps load times, reduce resources usage, and enhance overall user experience.",
      "Ensuring that front-end code functions properly across various browsers and devices by testing and debugging for compatibility issues.",
      "Collaborating with UI/UX designers to refine designs and with back-end developers to integrate front-end components with server-side logic and databases.",
      "Managing code changes, collaborate with team members, and deploy front-end code to production environments.",
    ],
  },

  {
    Icon: CiGrid31,
    title: "Backend Development",
    content: [
      "Writing server-side code using Node.js and it's framework Express to handle requests from client-side applications and generate dynamic content.",
      "Designing, implementing, and maintaining databases using technologies like SQL (e.g., MySQL, PostgreSQL) or NoSQL (e.g., MongoDB) to store and manage application data efficiently.",
      "Creating and maintaining APIs (Application Programming Interfaces) that allow communication between the front-end and back-end components of applications, as well as external services.",
      "Implementing security measures such as encryption, authentication, and authorization to protect sensitive data and prevent unauthorized access or attacks.",
      "Optimizing backend code and database queries to improve application performance, scalability, and response times, especially during high traffic periods.",
      "Integration with Third-Party Services: Integrating backend systems with external services, APIs, and platforms to add additional functionality or access external data sources.",
      "Designing and implementing scalable and reliable backend architectures that can handle increasing volumes of traffic and data without compromising performance or stability.",
      "Writing clear and comprehensive documentation for backend code and APIs, as well as conducting thorough testing to ensure functionality, reliability, and security.",
    ],
  },
];

export const CONTACT = [
  {
    Icon: BsTelephone,
    title: "Contact Me",
    subtitle: "+970 597 859 389",
  },
  {
    Icon: CiMail,
    title: "Email",
    subtitle: "ahmedghanim317@gmail.com",
  },
  {
    Icon: FaWhatsapp,
    title: "WhatsApp",
    subtitle: "+970 597 859 389",
  },
  {
    Icon: HiOutlineLocationMarker,
    title: "Location",
    subtitle: "Roni Saleh.St, Khanyounis, Gaza, Palestine",
  },
];

export const WORk_DATA = [
  {
    title: "Frontend Developer",
    subtitle: "Dash",
    date: "SEPT 2022 - OCT 2023",
  },
  {
    title: "Full-Stack Engineer",
    subtitle: "GetSpacy",
    date: "JAN 2023 - MAY 2023",
  },
  {
    title: "Full-Stack Web Developer",
    subtitle: "Musimy",
    date: "JUL 2022 - OCT 2022",
  },
  {
    title: "Frontend Web Developer",
    subtitle: "GGateway",
    date: "NOV 2021 - MAR 2022",
  },
  {
    title: "Frontend Web Developer",
    subtitle: "UpWork & Mostaql",
    date: "AUG 2020 - MAR 2022",
  },
];

export const EDUCATION_DATA = [
  {
    title: "Freelancing Boot-camp",
    subtitle: "Gaza Sky Geeks",
    date: "AUG 2022 - DEC 2022",
  },
  {
    title: "React-Native Training",
    subtitle: "PITA",
    date: "APR 2022 - SEPT 2022",
  },
  {
    title: "English For Business",
    subtitle: "Amideast",
    date: "FEB 2022 - MAY 2022",
  },
  {
    title: "Portfolio Club",
    subtitle: "Gaza Sky Geeks",
    date: "MAY 2021 - JUN 2021",
  },
  {
    title: "Bachelor Degree in Software Engineering",
    subtitle: "Al-Azhar University",
    date: "AUG 2018 - OCT 2023",
  },
];
